<template>
  <div class="grid-column-span-2_md grid-column-end-4_md flex flex-column justify-items-center vh75">
    <h1>Your financials</h1>
    <div class="font-size-4 mb3">
      <p>Time for some predictive analysis. Plug in your current financials, and we&rsquo;ll try and predict how they would look if you met the goals you set in previous steps.</p>
      <p>You can adjust these values anytime.</p>
    </div>
    <form
      action=""
      @submit.prevent="editRates">
      <fieldset>
        <lw-currency-input
          v-validate="'required|numeric'"
          ref="currentRevenue"
          :name="'currentRevenue'"
          :label="'Current annual revenue'"
          :hint="'This is all the money that came into your organization over the last twelve months.'"
          :align="'right'"
          :size="'large'"
          :type="'number'"
          :currency="organization.currency"
          v-model.number="currentRevenue"
          :error="errors.first('currentRevenue')"
          @input="editRates(false)"
        />
        <lw-currency-input
          v-validate="'required|numeric'"
          :name="'currentExpenses'"
          :label="'Current total annual expenses'"
          :hint="'How much did you spend over the past year, including taxes, salaries, and expenses?'"
          :align="'right'"
          :size="'large'"
          :type="'number'"
          :currency="organization.currency"
          v-model.number="currentExpenses"
          :error="errors.first('currentExpenses')"
          @input="editRates(false)"
        />
        <lw-text-input
          v-validate="'required|numeric'"
          :name="'profit'"
          :label="'Profit goal percentage'"
          :hint="'How much profit do you want to make? ' + currentProfit"
          :align="'right'"
          :size="'large'"
          :type="'number'"
          v-model.number="profitPercent"
          :error="errors.first('profit')"
          @input="editRates(false)"
        />
        <lw-text-input
          v-validate="'required|numeric'"
          :name="'activeClients'"
          :label="'Number of active clients'"
          :hint="'This is the number active clients who are using up your team‘s capacity over a year. Includes retainer clients, but not passive income or annual fees.'"
          :align="'right'"
          :size="'large'"
          :type="'number'"
          v-model.number="currentClients"
          :error="errors.first('activeClients')"
          @input="editRates(false)"
        />
        <lw-text-input
          v-validate="'required|numeric'"
          :name="'goalActiveClients'"
          :label="'Ideal number of active clients'"
          :hint="'This is how many active clients you <em>want</em> to work with over the next twelve months, including retainer clients. Fewer clients at higher value is the goal.'"
          :align="'right'"
          :size="'large'"
          :class="'mb2'"
          :type="'number'"
          v-model.number="goalClients"
          :error="errors.first('goalActiveClients')"
          @input="editRates(false)"
        />
      </fieldset>
      <div class="flex justify-content-space-between align-items-center align-baseline mb-margin grid-column-span-2_sm grid-column-span-7_md">
        <button
          class="invisible-button negative-button"
          @click.prevent="back"><svg-left/>Back</button>
        <button
          type="submit"
          class="large-button accent-button mr1"
          @click.prevent="editRates">Next</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as firebase from 'firebase'
import CurrencyInput from '../../livewires/CurrencyInput'
import TextInput from '../../livewires/TextInput'
import Left from '../../svgs/Left'

export default {
  components: {
    lwCurrencyInput: CurrencyInput,
    lwTextInput: TextInput,
    svgLeft: Left
  },
  data () {
    return {
      page: this.$route.params.id,
      currentRevenue: '',
      currentExpenses: '',
      currentClients: '',
      goalClients: '',
      profitPercent: ''
    }
  },
  computed: {
    ...mapGetters([
      'organization'
    ]),
    rate () {
      return this.$store.getters.rateCard(this.page)
    },
    proportions () {
      return this.$store.getters.revenueProportions(this.page)
    },
    currentProfit () {
      if (this.currentRevenue && this.currentExpenses) {
        return 'Looks like you‘re currently sitting around ' + Math.round((this.currentRevenue - this.currentExpenses) / this.currentRevenue * 100) + '%.'
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.$refs.currentRevenue.$el.children[0].focus()
  },
  methods: {
    editRates (next) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('saveState', false)
          const updated = firebase.default.firestore.FieldValue.serverTimestamp()
          let payload = { ...this.rate }
          payload.updated = updated
          payload.current.incoming = this.currentRevenue
          payload.current.outgoing = this.currentExpenses
          payload.current.clients = this.currentClients
          payload.goal.clients = this.goalClients
          payload.goal.profitProportion = this.profitPercent
          payload.id = this.page
          this.$store.dispatch('editRates', payload).then(response => {
            if (next) {
              this.$router.push({ name: 'newRateComplete', params: { id: this.page } })
            }
          })
        }
      })
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>
